import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { logoDark, logoLight } from '@react-apps/design-system';
import { useVerifyEmail } from '../hooks/use-verify-email';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  // Fluxo novo: o link é o NOSSO (`/verify-email?token=…`), não o oobCode do Firebase.
  const status = useVerifyEmail(searchParams.get('token'));

  const [isDark, setIsDark] = useState(() => {
    if (typeof window === 'undefined') return false;
    return document.documentElement.classList.contains('dark');
  });

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-(--color-bg-secondary) flex min-h-screen flex-col items-center justify-center px-4">
      <div className="flex w-full max-w-sm flex-1 flex-col items-center justify-center">
        <div className="mb-8">
          <img
            src={isDark ? logoDark : logoLight}
            alt="Primum"
            className="h-10 w-auto"
          />
        </div>

        <div className="border-(--color-border) bg-(--color-bg-primary) w-full rounded-2xl border p-8 shadow-sm">
          {status === 'loading' && (
            <p className="text-(--color-text-secondary) text-center text-sm">
              Confirmando seu e-mail…
            </p>
          )}

          {status === 'success' && (
            <div className="space-y-6">
              <div className="rounded-lg border border-green-200 bg-green-50 px-4 py-6 text-center dark:border-green-900 dark:bg-green-950">
                <svg
                  className="mx-auto mb-3 h-8 w-8 text-green-600 dark:text-green-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m4.5 12.75 6 6 9-13.5"
                  />
                </svg>
                <p className="text-sm font-semibold text-green-700 dark:text-green-400">
                  E-mail confirmado!
                </p>
                <p className="mt-2 text-sm text-green-700 dark:text-green-400">
                  Você já pode fechar esta aba ou acessar sua página de usuário.
                </p>
              </div>
              <Link
                to="/"
                className="bg-(--color-accent) flex w-full items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition hover:opacity-90"
              >
                Ir para minha página
              </Link>
            </div>
          )}

          {(status === 'invalid' ||
            status === 'expired' ||
            status === 'error') && (
            <div className="space-y-6">
              <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-6 text-center dark:border-red-900 dark:bg-red-950">
                <p className="text-sm font-medium text-red-700 dark:text-red-400">
                  {status === 'invalid' && 'Esse link não é válido.'}
                  {status === 'expired' &&
                    'Esse link expirou ou já foi usado. Peça um novo na tela de login.'}
                  {status === 'error' &&
                    'Não foi possível confirmar seu e-mail. Tente novamente.'}
                </p>
              </div>
              <Link
                to="/sign-in"
                className="bg-(--color-accent) flex w-full items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition hover:opacity-90"
              >
                Voltar para o login
              </Link>
            </div>
          )}
        </div>
      </div>

      <footer className="py-6">
        <p className="text-(--color-text-secondary) text-xs">
          © 2026 Grupo Primum. Todos os direitos reservados.
        </p>
      </footer>
    </div>
  );
}
